<template>
  <div>
    <back :title="titlename"></back>
    <!-- 预约办 -->
    <van-form>
      <van-field v-model.trim="name" name="姓名" label="姓名" placeholder="请填写" />
      <van-field v-model.trim="idnumber" name="身份证号" label="身份证号" placeholder="请填写" />
      <van-field v-model.trim="address" name="户籍地址" label="户籍地址" placeholder="请填写" />
      <van-field class="phone" v-model.trim="phone" type="number" name="手机号" label="手机号" placeholder="请填写" />
      <div class="yzm">
        <van-field class="phone" v-model.trim="yzm" maxlength="4" type="number" name="验证码" label="验证码"
          placeholder="请填写" />
		<img :src="imgUrl" @click="getyzm2" />
        <!-- <van-button type="primary" native-type="" :disabled="disabled" @click="getyzm">{{yzminfo}}</van-button> -->
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="onSubmit">确定</van-button>
      </div>
      <!-- 预约网络点下拉框选项 -->
    </van-form>
  </div>

</template>

<script>
  import {
    Form,
    Toast
  } from 'vant'
  export default {
    data() {
      return {
        titlename: "实名认证",
        name: "",
        phone: "",
        idnumber: "",
        yzm: "",
        yzminfo: "验证码",
        disabled: false,
        count: 60,
        address:"",
		openId:"",
		imgUrl:""
      };
    },
	created() {
		//this.openId = "oLtkvuA-fIsU__M23ICDg4DGZOoc"
		this.openId = this.$store.state.openId
		this.getUser()
		this.imgUrl = this.$store.state.host + "/interface/getCode?PHONE="+this.openId+"&"+Math.random()
	},
    methods: {
		// 提交
		getUser() {
		  this.$http.post(this.$store.state.host + "/interface/getUser", {
		      openid:this.openId
		    }, {
		      emulateJSON: true
		    })
		    .then(res => {
		      //发送成功
		      if (res.body.code == 0) {
		        if(res.body.userPd != null){
					this.name = res.body.userPd.realname
					this.idnumber = res.body.userPd.card
					this.address = res.body.userPd.address
					this.phone = res.body.userPd.phone
				}
		      }
		      else{
		         Toast(res.body.msg)
		      }
		
		      //if()
		    }, res => {
		      //发送失败
		    })
		},
		
		//图形验证码
	  getyzm2(){
		  this.imgUrl = this.$store.state.host + "/interface/getCode?PHONE="+this.openId+"&"+Math.random()
		  this.$forceUpdate()
	  },	
		
      // 发送验证码
      getyzm() {
        if (this.phone == "" || this.phone == undefined) {
          Toast("请输入手机号")
          return false
        }
        if (this.phone.length != 11) {
          Toast("手机号格式不正确，请重新输入")
          return false
        }
        var that = this
        this.disabled = true
        var time = setInterval(function() {
          that.count = that.count - 1
          if (that.count == -1) {
            clearInterval(time)
            that.count = 60
            this.disabled = false
          }
          that.yzminfo = that.count + 's'
        }, 1000)
        this.$http.post(this.$store.state.host + "/interface/sendSms", {
            PHONE: this.phone
          }, {
            emulateJSON: true
          })
          .then(res => {
            //发送成功
            console.log(res)
            if (res.body.code == 0) {
              Toast("验证码发送成功！")
            }
            else{
               Toast(res.body.msg)
            }
            //if()
          }, res => {
            //发送失败
          })
      },
      // 身份证验证
      IdentityCodeValid(code) {
        var city = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江 ",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北 ",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏 ",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外 "
        };
        var tip = "";
        var pass = true;
        if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
          tip = "身份证号格式错误";
          pass = false;
        } else if (!city[code.substr(0, 2)]) {
          tip = "地址编码错误";
          pass = false;
        } else {
          //18位身份证需要验证最后一位校验位
          if (code.length == 18) {
            code = code.split('');
            //∑(ai×Wi)(mod 11)//加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            //校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
              ai = code[i];
              wi = factor[i];
              sum += ai * wi;
            }
            var last = parity[sum % 11];
            if (parity[sum % 11] != code[17]) {
              tip = "校验位错误";
              pass = false;
            }
          }
        }
        if (!pass) {
          console.log(tip);
        }
        return pass;
      },
      // 提交
      onSubmit() {
        if (this.name == "" || this.name == undefined) {
          Toast("请输入姓名")
          return false
        }
        if (this.idnumber == "" || this.idnumber == undefined) {
          Toast("请输入身份证号")
          return false
        }
        if(!this.IdentityCodeValid(this.idnumber)){
          Toast("身份证号格式不正确")
          return false
        }
        if (this.address == "" || this.address == undefined) {
          Toast("请输入户籍地址")
          return false
        }
        if (this.phone == "" || this.phone == undefined) {
          Toast("请输入手机号")
          return false
        }
        if (this.phone.length != 11) {
          Toast("手机号格式不正确，请重新输入")
          return false
        }
        if (this.yzm == "" || this.yzm == undefined) {
          Toast("请输入验证码")
          return false
        }
        this.$http.post(this.$store.state.host + "/interface/shimingSave", {
            phone: this.phone,
            openid:this.$store.state.openId,
            verifyCode:this.yzm,
            card:this.idnumber,
            realname:this.name,
            address:this.address
          }, {
            emulateJSON: true
          })
          .then(res => {
            //发送成功
            console.log(res)
            if (res.body.code == 0) {
              Toast("绑定成功")
              this.$router.push('/')
            }
            else{
               Toast(res.body.msg)
            }

            //if()
          }, res => {
            //发送失败
          })
      }
    }
  };
</script>

<style lang="less" scoped>
  /deep/.van-form {
    .van-button--info {
      background-color: #f28033;
      border: 1px solid #f28033;
      border-radius: 5px;
      padding: .3rem 0px;
    }

    .van-cell {
      font-size: .26rem;
    }

  }

  /deep/.van-field__control {
    text-align: right;
  }

  .yzm {
    position: relative;

    /deep/.van-cell__value {
      input {
        text-align: left;
      }
    }

    img {
      position: absolute;
      right: 16px;
      top: 5px;
      padding: 7px 25px;
      height: auto;
      background-color: #f28033;
      border: 1px solid #f28033;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/realinfo.vue